<template>
  <div class="section__body">
    <ul class="usersOffice">
      <li class="usersOffice__item" v-for="(user, $index) in getUsers" :key="user.id">
        <div class="usersOffice__user">
          <router-link :to="`/doctor/users/edit/${user.id}`" class="usersOffice__user-link">
            {{ user.name }}
          </router-link>
        </div>

        <div class="usersOffice__actions">
          <a @click="removeUser($index)">
            <dr-icon class="usersOffice__actions-remove" :color="'#e57066'" :name="'excluiAlerta'" />
          </a>
        </div>
      </li>
    </ul>

    <footer class="section__footer section__footer--centered" id="TOUR_USERS_BTN">
      <router-link
        :to="{name: 'DoctorUsersOfficeNew'}"
        tag="button"
        class="btn btn btn-primary">
        Novo perfil de atendimento
      </router-link>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['users'],

  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    }),

    getUsers () {
      return this.users
    }
  },

  methods: {
    removeUser (ind) {
      const self = this
      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: `Tem certeza que deseja remover o usuário?`,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose (v) {
          if (!v) {
            this.$store.dispatch('setModalConfirm')
          } else {
            this.fn_SHOW_PROGRESS()

            this.$http
              .delete(`doctor/doctor_office/${self.office.id}/user/${self.users[ind].id}`, this.$store.getters.getAuthHeader)
              .then(
                (res) => {
                  self.$emit('success', true)
                  this.$store.dispatch('setModalConfirm')
                  this.$store.dispatch('setModalAlert', {
                    title: 'Sucesso',
                    body: 'Usuário removido com sucesso',
                    size: 'md',
                    active: true
                  })
                  self.$emit('update', true)
                  self.fn_HIDE_PROGRESS()
                }
              )
              .catch(err => console.log(err))
          }
        },
        size: 'md',
        active: true
      })
    }
  }
}
</script>
